var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: 0,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B08F762-9707-40DD-BD20-5770D993F1E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 11.0403987 0 11.0403987 21.8096338 0 21.8096338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 47.8026501 0 47.8026501 68.2139918 0 68.2139918"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-PROPOSAL-00",
    transform: "translate(-330.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_logo",
    transform: "translate(330.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#FCBF10",
    points: "0 7.98248177 32.9542094 16.2374282 32.9542094 51.9771867 0 60.2321331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fillOpacity: 0.8,
    fill: "#4971B7",
    points: "10.5019678 4.71695645 51.0607556 14.8771302 51.0607556 53.3368616 10.5019678 63.4970353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(21.728166, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fillOpacity: 0.8,
    fill: "#EF6422",
    mask: "url(#mask-4)",
    points: "0 0 47.8026501 11.973489 47.8026501 56.2408144 0 68.2143033"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalLogo);
export default __webpack_public_path__ + "static/media/portal_logo.f3e0888b55afe75318eb431bc8e4928e.svg";
export { ForwardRef as ReactComponent };